import { AxiosHeaders } from "axios";

export const downloadFileHelper = (fileUrl: string, fileName: string) => {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadResponseAsFile = (
  data: Blob | undefined,
  headers: AxiosHeaders,
) => {
  if (data && headers) {
    const contentDisposition = headers.get("Content-disposition") as
      | string
      | undefined;
    const filename = contentDisposition?.match(/filename="?([^"]+)"?/)?.[1];

    if (!filename) {
      throw new Error("Filename not found in headers");
    }

    const url = window.URL.createObjectURL(data);
    downloadFileHelper(url, filename);
    return;
  }

  throw new Error("No data to download");
};
